
import React from 'react';
import { Link } from 'react-router-dom';

export const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-darkgrey mb-6">
            Make your next offer in as little as 48 hours
          </h2>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8">
            <a 
              href="http://cutshort.io?auth=employer" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-brand-blue hover:bg-brand-blue/90 text-white px-8 py-4 rounded-xl text-lg font-medium transition-all shadow-md hover:shadow-xl hover:translate-y-[-2px] inline-block text-center"
            >
              Start for free
            </a>
            
            <a 
              href="https://cutshort.io/a/generic-emp-form" 
              target="_blank" 
              rel="noopener noreferrer"
              className="border border-brand-blue/30 hover:border-brand-blue/60 text-brand-blue px-8 py-4 rounded-xl text-lg font-medium transition-all hover:bg-brand-blue/5 inline-block text-center"
            >
              Get a callback
            </a>
          </div>
          
          <p className="text-brand-grey mt-8">
            Don't have bandwidth and time to hire on your own?{' '}
            <Link to="/" className="text-brand-blue hover:text-brand-blue/80 hover:underline">
              Check Sourcing Assistant
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};
